import React from "react";
import { useInView } from "react-intersection-observer";

// components
import Accordion from "./Accordian";

//styles
import * as styles from "./Faq.module.css";

const FaqComponent = props => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div>
      <div
        ref={ref}
        className={`container-fluid scroll_animate ${inView && "inview"} ${
          styles.faq
        }`}
      >
        <div className="row">
          <div className="col-12">
            <h2 className={styles.heading}>Frequently asked questions</h2>
            <p className={styles.faq__para}>Let’s Get Facts Right!</p>
          </div>
        </div>

        <div className="row">
          <div className={`col-md-12 ${styles.accordionTop}`}>
            <Accordion
              faqDetails={props.faqDetails}
              handleMixpanelCTA={props.handleMixpanelCTA}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqComponent;
